module.exports = {
  url: '/blog/:newsTag',
  template: require('raw!templates/blog/blog.html'),
  controller: BlogController,
  controllerAs: 'newsCtrl',
  params: {
    newsTag: {
        value: '',
        squash: true
      }
  }
}

function BlogController($scope, $state, $stateParams, store, contentful, $uibModal, $window, $sce) {
  var vm = this;
  $window.scrollTo(0,0);
  $scope.trustSrc = function(src) {
    return $sce.trustAsResourceUrl(src);
  }

  $scope.slide = {
    'blogNav': true
  }

vm.search = '';
vm.allTopics = [];
vm.allTags = [];

  contentful.entries('content_type=blogPage').then(function(res) {
    // console.log('blog data', res);
    $scope.blog = res.data.items[0];
    $scope.mainPage = "blog";
    // console.log('page = ', $scope.mainPage);
    var seoData = res.data.items[0];
    if (seoData.fields.seoTitle) {
      document.title = seoData.fields.seoTitle;
    }
    if (seoData.fields.seoDescription) {
      var meta = document.getElementsByTagName("meta");
      for (var i = 0; i < meta.length; i++) {
        if (meta[i].name.toLowerCase() === "description") {
          meta[i].content = seoData.fields.seoDescription;
        }
      }
    }
  });

vm.options = {
  currentPage: 1
};
vm.featuredNews = [];
vm.allNews = [];
vm.newsArchive = [];
vm.featuredArchive = [];
vm.newArchiveTemp = [];
vm.ftArchiveTemp = [];

contentful.entries('content_type=blogPost&include=3&limit=1000').then(function(res) {
  var entries = res.data;
  var count = 0;
  entries.items.forEach(function(entry) {
    vm.newsArchive.push(entry);
    vm.allNews.push(entry);
    if (entry.fields.topics) {
      if (vm.allTopics.indexOf(entry.fields.topics[0].fields.topic) == -1) {
        vm.allTopics.push(entry.fields.topics[0].fields.topic);
      } else {}
    }
    if (entry.fields.tags) {
      if (vm.allTags.indexOf(entry.fields.tags) == -1) {
        vm.allTags.push(entry.fields.tags);
        // console.log('All tags', vm.allTags);
      } else {}
    }
  }, function(res) {
    // console.log('error' + res.status);
  });
})

vm.setCurrentNews = function(news) {
  store.set('currentNews', news);
  if (news.fields.title) {
    var articleNameSlug = Slug.slugify(news.fields.title);
  } else if (news.fields.newsArticle.fields.title) {
    var articleNameSlug = Slug.slugify(news.fields.newsArticle.fields.title);
  }
  $state.go('site.blog-detail', {
    articleId: news.sys.id,
    articleName: articleNameSlug
  });
};
vm.searchandPop = function() {
  vm.allNews = [];
  if (vm.search.length < 1) {
    vm.allNews = vm.newsArchive;
  } else {
    vm.newsArchive.forEach(function(entry) {
      if (entry.fields && entry.fields.title && entry.fields.summary && entry.fields.body) {
        if (entry.fields.title.indexOf(vm.search) > -1) {
          vm.allNews.push(entry);
        } else if (entry.fields.summary.indexOf(vm.search) > -1) {
          vm.allNews.push(entry);
        } else if (entry.fields.body.indexOf(vm.search) > -1) {
          vm.allNews.push(entry);
        } else if (entry.fields.tags) {
          entry.fields.tags.forEach(function(tag) {
            if (tag === vm.search) {
              vm.allNews.push(entry)
            }
          })
        } else {}
      }
    });
  }
};
vm.selectSearchTopic = function(topic) {
    if (vm.searchTopic !== topic) {
        $state.go('site.blog', {
            newsTopic: topic
        });
    } else {
      // console.log("hey");
        $state.go('site.blog', {
            newsTopic: ''
        });
    }
};
vm.initialSearch = function() {
  vm.allNews = [];
  if (vm.search.length < 1) {
    vm.allNews = vm.newsArchive;
  } else {
    vm.newsArchive.forEach(function(entry) {
      if (entry.fields && entry.fields.title && entry.fields.summary && entry.fields.body) {
        if (entry.fields.title.indexOf(vm.search) > -1) {
          vm.allNews.push(entry);
          $scope.$apply();
        } else if (entry.fields.summary.indexOf(vm.search) > -1) {
          vm.allNews.push(entry);
          $scope.$apply();
        } else if (entry.fields.body.indexOf(vm.search) > -1) {
          vm.allNews.push(entry);
          $scope.$apply();
        } else if (entry.fields.tags) {
          entry.fields.tags.forEach(function(tag) {
            if (tag === vm.search) {
              vm.allNews.push(entry)
              $scope.$apply()
            }
          })
        } else {}
      };
    });
  }
};
$scope.items = [1,2,3,4,5];
   $scope.selected = [];

   $scope.toggle = function (item, list) {
     var idx = list.indexOf(item);
     if (idx > -1) {
       list.splice(idx, 1);
     }
     else {
       list.push(item);
     }
   };

   $scope.exists = function (item, list) {
     return list.indexOf(item) > -1;
   };

vm.repopulateNews = function() {
  if (vm.filter.topic === 'ALL') {
    vm.allNews = vm.newsArchive;
    vm.featuredNews = vm.featuredArchive;
  } else {
    vm.allNews = [];
    vm.featuredNews = [];
    vm.featuredArchive.forEach(function(entry) {
      var entry = entry;
      if (entry.fields.newsArticle.fields && entry.fields.newsArticle.fields.topics) {
        entry.fields.newsArticle.fields.topics.forEach(function(topic) {
          if (topic.fields.topic === vm.filter.topic) {
            if (vm.featuredNews.indexOf(entry) == -1) {
              vm.featuredNews.push(entry);
            } else {}
          }
        });
      }
    });
    vm.newsArchive.forEach(function(entry) {
      var entry = entry;
      if (entry.fields && entry.fields.topics) {
        entry.fields.topics.forEach(function(topic) {
          if (topic.fields.topic === vm.filter.topic) {
            if (vm.allNews.indexOf(entry) == -1) {
              vm.allNews.push(entry);
            } else {}
          }
        });
      }
    });
  }
  $state.go('site.blog', {
      newsTopic: vm.filter.topic
  });
};

if ($state.params.newsTopic) {
  vm.filter = {
    year: '',
    topic: $state.params.newsTopic
  };
  setTimeout(function() {
    vm.repopulateNews();
  }, 1000);
} else {
  vm.filter = {
    year: '',
    topic: 'ALL'
  };
}
if ($state.params.author) {
  setTimeout(function() {
    vm.repopulateNewsByAuthor()
  }, 1000);
} else {}
vm.delay = {
  'show': false
};
setTimeout(function() {
  vm.delay = {
    'show': true
  };
  $scope.$apply();
}, 1000);
setTimeout(function() {
  if ($stateParams.newsTag) {
    vm.search = $stateParams.newsTag;
    $scope.$apply();
    vm.initialSearch();
  }
}, 1500);

contentful.entries('content_type=topics').then(function(res) {
  $scope.allTags = res.data.items;
});

contentful.entries('content_type=blogTags').then(function(res) {
  $scope.blogTags = res.data.items;
});
$(function () {
    var sidebar = $('.sidebar');
    var content = $('.content');
    var top = sidebar.offset().top - parseFloat(sidebar.css('margin-top'));

    $(window).scroll(function (event) {
      var y = $(this).scrollTop();
      if (y >= top) {
        sidebar.addClass('fixed');
        content.addClass('margin-left')
      } else {
        sidebar.removeClass('fixed');
          content.removeClass('margin-left')
      }
    });
});
}



/** WEBPACK FOOTER **
 ** ./components/templates/blog/blog.js
 **/